var x = {}, ae = { exports: {} };
(function(e) {
  function t(o) {
    return o && o.__esModule ? o : {
      default: o
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ae);
var ce = ae.exports, y = { exports: {} }, _ = { exports: {} }, b = { exports: {} }, F;
function ie() {
  return F || (F = 1, function(e) {
    function t(o, r) {
      (r == null || r > o.length) && (r = o.length);
      for (var n = 0, s = Array(r); n < r; n++)
        s[n] = o[n];
      return s;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(b)), b.exports;
}
var H;
function le() {
  return H || (H = 1, function(e) {
    var t = ie();
    function o(r) {
      if (Array.isArray(r))
        return t(r);
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(_)), _.exports;
}
var h = { exports: {} }, D;
function xe() {
  return D || (D = 1, function(e) {
    function t(o) {
      if (typeof Symbol != "undefined" && o[Symbol.iterator] != null || o["@@iterator"] != null)
        return Array.from(o);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(h)), h.exports;
}
var d = { exports: {} }, z;
function ve() {
  return z || (z = 1, function(e) {
    var t = ie();
    function o(r, n) {
      if (r) {
        if (typeof r == "string")
          return t(r, n);
        var s = {}.toString.call(r).slice(8, -1);
        return s === "Object" && r.constructor && (s = r.constructor.name), s === "Map" || s === "Set" ? Array.from(r) : s === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s) ? t(r, n) : void 0;
      }
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(d)), d.exports;
}
var g = { exports: {} }, B;
function ye() {
  return B || (B = 1, function(e) {
    function t() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(g)), g.exports;
}
var K;
function _e() {
  return K || (K = 1, function(e) {
    var t = le(), o = xe(), r = ve(), n = ye();
    function s(a) {
      return t(a) || o(a) || r(a) || n();
    }
    e.exports = s, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(y)), y.exports;
}
var C = { exports: {} }, U;
function be() {
  return U || (U = 1, function(e) {
    function t(o, r) {
      if (!(o instanceof r))
        throw new TypeError("Cannot call a class as a function");
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(C)), C.exports;
}
var q = { exports: {} }, R = { exports: {} }, P = { exports: {} }, G;
function E() {
  return G || (G = 1, function(e) {
    function t(o) {
      "@babel/helpers - typeof";
      return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(o);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(P)), P.exports;
}
var A = { exports: {} }, V;
function he() {
  return V || (V = 1, function(e) {
    var t = E().default;
    function o(r, n) {
      if (t(r) != "object" || !r)
        return r;
      var s = r[Symbol.toPrimitive];
      if (s !== void 0) {
        var a = s.call(r, n || "default");
        if (t(a) != "object")
          return a;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (n === "string" ? String : Number)(r);
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(A)), A.exports;
}
var Y;
function de() {
  return Y || (Y = 1, function(e) {
    var t = E().default, o = he();
    function r(n) {
      var s = o(n, "string");
      return t(s) == "symbol" ? s : s + "";
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(R)), R.exports;
}
var J;
function ge() {
  return J || (J = 1, function(e) {
    var t = de();
    function o(n, s) {
      for (var a = 0; a < s.length; a++) {
        var i = s[a];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(n, t(i.key), i);
      }
    }
    function r(n, s, a) {
      return s && o(n.prototype, s), a && o(n, a), Object.defineProperty(n, "prototype", {
        writable: !1
      }), n;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(q)), q.exports;
}
var O = { exports: {} }, I = { exports: {} }, Q;
function Ce() {
  return Q || (Q = 1, function(e) {
    function t(o) {
      if (o === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return o;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(I)), I.exports;
}
var X;
function qe() {
  return X || (X = 1, function(e) {
    var t = E().default, o = Ce();
    function r(n, s) {
      if (s && (t(s) == "object" || typeof s == "function"))
        return s;
      if (s !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return o(n);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(O)), O.exports;
}
var T = { exports: {} }, Z;
function ue() {
  return Z || (Z = 1, function(e) {
    function t(o) {
      return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
        return r.__proto__ || Object.getPrototypeOf(r);
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(o);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(T)), T.exports;
}
var S = { exports: {} }, M = { exports: {} }, $;
function L() {
  return $ || ($ = 1, function(e) {
    function t(o, r) {
      return e.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, s) {
        return n.__proto__ = s, n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(o, r);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(M)), M.exports;
}
var m;
function Re() {
  return m || (m = 1, function(e) {
    var t = L();
    function o(r, n) {
      if (typeof n != "function" && n !== null)
        throw new TypeError("Super expression must either be null or a function");
      r.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: r,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(r, "prototype", {
        writable: !1
      }), n && t(r, n);
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(S)), S.exports;
}
var w = { exports: {} }, N = { exports: {} }, ee;
function Pe() {
  return ee || (ee = 1, function(e) {
    function t(o) {
      try {
        return Function.toString.call(o).indexOf("[native code]") !== -1;
      } catch (r) {
        return typeof o == "function";
      }
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(N)), N.exports;
}
var k = { exports: {} }, j = { exports: {} }, re;
function Ae() {
  return re || (re = 1, function(e) {
    function t() {
      try {
        var o = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        }));
      } catch (r) {
      }
      return (e.exports = t = function() {
        return !!o;
      }, e.exports.__esModule = !0, e.exports.default = e.exports)();
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(j)), j.exports;
}
var te;
function Oe() {
  return te || (te = 1, function(e) {
    var t = Ae(), o = L();
    function r(n, s, a) {
      if (t())
        return Reflect.construct.apply(null, arguments);
      var i = [null];
      i.push.apply(i, s);
      var f = new (n.bind.apply(n, i))();
      return a && o(f, a.prototype), f;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(k)), k.exports;
}
var oe;
function Ie() {
  return oe || (oe = 1, function(e) {
    var t = ue(), o = L(), r = Pe(), n = Oe();
    function s(a) {
      var i = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
      return e.exports = s = function(u) {
        if (u === null || !r(u))
          return u;
        if (typeof u != "function")
          throw new TypeError("Super expression must either be null or a function");
        if (i !== void 0) {
          if (i.has(u))
            return i.get(u);
          i.set(u, c);
        }
        function c() {
          return n(u, arguments, t(this).constructor);
        }
        return c.prototype = Object.create(u.prototype, {
          constructor: {
            value: c,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), o(c, u);
      }, e.exports.__esModule = !0, e.exports.default = e.exports, s(a);
    }
    e.exports = s, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(w)), w.exports;
}
var l = {}, ne;
function Te() {
  return ne || (ne = 1, Object.defineProperty(l, "__esModule", {
    value: !0
  }), l.fixSvgNameCasing = void 0, l.fixSvgNameCasing = function(t) {
    var o = {
      preserveaspectratio: "preserveAspectRatio",
      systemlanguage: "systemLanguage",
      viewbox: "viewBox"
    };
    return o[t] || t;
  }), l;
}
var p = ce;
Object.defineProperty(x, "__esModule", {
  value: !0
});
x.Icon = void 0;
var Se = p(_e()), Me = p(be()), we = p(ge()), Ne = p(qe()), se = p(ue()), ke = p(Re()), je = p(Ie()), Ee = Te();
function Le(e, t, o) {
  function r() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch (n) {
      return !1;
    }
  }
  return t = (0, se.default)(t), (0, Ne.default)(e, r() ? Reflect.construct(t, o || [], (0, se.default)(e).constructor) : t.apply(e, o));
}
x.Icon = /* @__PURE__ */ function(e) {
  function t() {
    return (0, Me.default)(this, t), Le(this, t, arguments);
  }
  return (0, ke.default)(t, e), (0, we.default)(t, [{
    key: "connectedCallback",
    value: (
      // eslint-disable-next-line max-statements
      function() {
        if (!this.connectedOnce) {
          var r = this.getAttribute("svg");
          r = /<svg/.test(r) ? r : "<svg></svg>", this.innerHTML = r;
        }
        this.connectedOnce = !0;
        for (var n = this.querySelector("svg"), s = t.observedAttributes, a = 0, i = Array.from(this.attributes); a < i.length; a++) {
          var f = i[a], u = f.name, c = f.value, v = (0, Ee.fixSvgNameCasing)(u);
          s.includes(v) || (n.setAttribute(v, c), this.removeAttribute(v));
        }
        if (this.setAttribute("role", "img"), n.setAttribute("aria-hidden", "true"), this.attributes.getNamedItem("rotate")) {
          var pe = this.attributes.getNamedItem("rotate").value;
          n.style.setProperty("transform", "rotate(".concat(pe, "deg)"));
        }
        if (this.attributes.getNamedItem("container-class")) {
          var W, fe = this.getAttribute("container-class");
          (W = this.classList).add.apply(W, (0, Se.default)(fe.split(" ")));
        }
      }
    )
  }, {
    key: "attributeChangedCallback",
    value: function(r, n, s) {
      if (this.connectedOnce) {
        var a = this.querySelector("svg");
        switch (r) {
          case "rotate":
            a.style.setProperty("transform", "rotate(".concat(s, "deg)"));
            break;
        }
      }
    }
    // This controls which attributes are copied from the top-level
    // <leaf-icon> to <svg>, and also attributeChangedCallback
  }], [{
    key: "observedAttributes",
    get: function() {
      return [
        "svg",
        // set in this component as 'img'
        "role",
        // a string
        "aria-label",
        // a boolean
        "aria-hidden",
        // a boolean
        "spin",
        // a boolean
        "pulse",
        // a positive or negative number of degrees to rotate
        "rotate",
        // a string of "vertical", "horizontal", or "both"
        "flip",
        // a space separated string of classes
        "container-class"
      ];
    }
  }]);
}(/* @__PURE__ */ (0, je.default)(HTMLElement));
var We = x;
window.customElements.get("leaf-icon") === void 0 && window.customElements.define("leaf-icon", We.Icon);
